import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=8e3dac16&scoped=true&"
import script from "./user_info.vue?vue&type=script&lang=ts&"
export * from "./user_info.vue?vue&type=script&lang=ts&"
import style0 from "./user_info.vue?vue&type=style&index=0&id=8e3dac16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3dac16",
  null
  
)

export default component.exports